import { cx } from '@emotion/css';
import type { FC } from 'react';

import { MotifComponent, useMotifStyles } from '../../motif';
import {
  aiLocalizationBannerContentCss,
  aiLocalizationBannerCss,
  aiLocalizationBannerDescriptionCss,
  aiLocalizationBannerTitleCss,
} from './styles';

type AiLocalizationBannerProps = {
  title?: string;
  description?: string;
};

// TODO: Investigate whether this single-purpose component belongs in sdsm or should be moved to web.
export const AiLocalizationBanner: FC<AiLocalizationBannerProps> = ({ title, description }) => {
  useMotifStyles(MotifComponent.AI_LOCALIZATION_BANNER);

  if (!title && !description) {
    return null;
  }

  return (
    <div className={cx(MotifComponent.AI_LOCALIZATION_BANNER, aiLocalizationBannerCss)}>
      <div className={aiLocalizationBannerContentCss}>
        {title && <div className={aiLocalizationBannerTitleCss}>{title}</div>}
        {description && <div className={aiLocalizationBannerDescriptionCss}>{description}</div>}
      </div>
    </div>
  );
};
